import React from "react";
import { Accordion, Card, Button } from "react-bootstrap";
import { FaQuestionCircle } from "react-icons/fa";
import { SuggestionsProvider, useSuggestions } from "../../pages/RelatoriosDelivery/ChatBotView/SuggestionsContext";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

export default function SuggestionsModal({ data, onSuggestionClick, loading }) {
    const { isOpen, setIsOpen } = useSuggestions();

    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);

    return (
        <>
            <FaQuestionCircle
                className="doubts-btn"
                color="#212529"
                size={32}
                onClick={handleOpen}
            />

            {isOpen && (
                <div className="modal-suggestions">
                    <div className="modal-suggestions--header">
                        <h3>Sugestões</h3>
                        <button
                            className="close-btn"
                            onClick={handleClose}
                            aria-label="Fechar sugestões"
                        >
                            x
                        </button>
                    </div>

                    <div className="modal-suggestions--content">
                        {loading ? (
                            <div className="text-center mt-4">Carregando sugestões...</div>
                        ) : (
                            <Accordion>
                                {data.map((funcionalidade, index) => (
                                    <Card className="accordion-item-suggestion" key={index}>
                                        <Card.Header>
                                            <OverlayTrigger
                                                placement="left"
                                                overlay={
                                                    <Tooltip id={`tooltip-${index}`}>
                                                        {funcionalidade.descricao}
                                                    </Tooltip>
                                                }
                                            >
                                                <Accordion.Toggle
                                                    as={Button}
                                                    variant="text"
                                                    eventKey={index.toString()}
                                                    className="accordion-toggle-suggestion"
                                                >
                                                    {funcionalidade.nome}
                                                </Accordion.Toggle>
                                            </OverlayTrigger>
                                        </Card.Header>

                                        <Accordion.Collapse eventKey={index.toString()}>
                                            <Card.Body>
                                                <ul>
                                                    {funcionalidade.prompts.map((prompt, idx) => (
                                                        <li
                                                            key={idx}
                                                            onClick={() => onSuggestionClick(prompt)}
                                                            style={{ cursor: "pointer" }}
                                                            className="suggestion-item"
                                                        >
                                                            {prompt}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                ))}
                            </Accordion>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}
